import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { BaseComponent } from '@app/finxone-web-frontend/app/Modules/shared/widgets/base/base.component';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { NotificationService } from '@app/finxone-web-frontend/app/lib/services/notification-service/notification-service.service';
import { getNavigationUrl } from '@app/finxone-web-frontend/app/lib/utils/utils';
import {
  BaseCssProperties,
  NavigationOptionEnum,
  ProviderClass,
  UiZoneWidgetAttributeConfig,
  baseCssConfigStyle,
} from '@finxone-platform/shared/sys-config-types';

@Component({
  selector: 'finxone-platform-notification-bell',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './notification-bell.component.html',
  styleUrl: './notification-bell.component.scss',
})
export class NotificationBellComponent extends BaseComponent implements OnInit {
  public icon: string;
  public iconStyle?: baseCssConfigStyle;
  public unreadCount = 0;
  private notificationsCountListenerRegistered = false;
  constructor(
    private configService: ConfigService,
    public dataIn: ProviderClass<UiZoneWidgetAttributeConfig>,
    private router: Router,
    private notificationService: NotificationService,
  ) {
    super();
    this.icon = this.dataIn.attri?.widgetProperties?.icon ?? 'bell';
  }

  ngOnInit(): void {
    if (this.dataIn) {
      this.attri = this.dataIn.attri ?? null;
      this.onLoadWidgetConfiguration();
      this.initNovuService();
    }
  }

  private async initNovuService() {
    const isWorkflow = this.configService.getActiveConfigType().isWorkflow;
    if (isWorkflow) return;
    if (!this.notificationService.novuServiceInitialised) {
      this.notificationService.waitForNovuInitialization().then(() => {
        this.fetchUnseenNotificationsCount();
      });
    } else this.fetchUnseenNotificationsCount();
  }

  private fetchUnseenNotificationsCount() {
    this.notificationService.novuService.notifications._inboxService
      .count({ filters: [{ read: false }] })
      .then((response) => {
        if (response?.data) {
          this.unreadCount = response.data[0].count;
        }
        this.setupNotificationsCountListener();
      })
      .catch((error) => {
        console.error(error);
      });
  }

  private setupNotificationsCountListener() {
    if (!this.notificationsCountListenerRegistered) {
      // Listener for refreshing unread count reactively after widget's been loaded
      this.notificationService.novuService.on('notifications.unread_count_changed', (data) => {
        this.unreadCount = data.result.total;
      });
      this.notificationsCountListenerRegistered = true;
    }
  }

  private onLoadWidgetConfiguration(): void {
    this.contentStyle = this.configService.getSpecificBaseCssStyle(this.attri, [
      BaseCssProperties.MARGIN,
      BaseCssProperties.PADDING,
      BaseCssProperties.BACKGROUND_COLOR,
      BaseCssProperties.BORDER,
      BaseCssProperties.BOX_SHADOW,
    ]);

    this.iconStyle = this.configService.getSpecificBaseCssStyle(this.attri, [
      BaseCssProperties.ICON_SIZE,
      BaseCssProperties.ICON_COLOR,
    ]);
    this.iconStyle = {
      ...this.iconStyle,
      display: 'flex',
    };
  }

  public onNotificationBellClick() {
    const redirectUrl = getNavigationUrl(this.dataIn.attri);
    if (redirectUrl && redirectUrl === NavigationOptionEnum.USE_AS_BLANK) return;
    const url = '/zones/profile/notification-centre';
    const finalUrl = redirectUrl || url;
    this.router.navigateByUrl(finalUrl);
  }
}
